import React, { useState, useEffect } from "react";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState(
    localStorage.getItem("rememberedUsername") || ""
  );
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(
    !!localStorage.getItem("rememberedUsername")
  );
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError("");

    if (!username.trim() || !password) {
      setError("Username and password are required");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch("/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", // send/receive PHP session cookie
        body: JSON.stringify({ username, password }),
      });

      let data;
      try {
        data = await res.json();
      } catch {
        data = null;
      }

      if (!res.ok || !data) {
        setError(data?.message || "Login failed. Please check your credentials.");
        return;
      }

      if (data.success) {
        // UI flag only – real auth via PHP session
        sessionStorage.setItem("isLoggedIn", "true");

        if (rememberMe) {
          localStorage.setItem("rememberedUsername", username);
        } else {
          localStorage.removeItem("rememberedUsername");
        }

        onLogin(true);
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      console.error(err);
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        background:
          "radial-gradient(circle at top, #ffe9cc 0, #fff6e9 40%, #fff 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
      }}
    >
      <div
        style={{
          position: "relative",
          background: "#ffffff",
          borderRadius: "18px",
          padding: "32px 28px 26px",
          width: "100%",
          maxWidth: "420px",
          boxShadow: "0 18px 45px rgba(0, 0, 0, 0.12)",
          border: "1px solid #ffe0b3",
        }}
      >
        {/* top accent bar */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            borderTopLeftRadius: "18px",
            borderTopRightRadius: "18px",
            background:
              "linear-gradient(90deg, #f55a00 0%, #ff8c42 50%, #f5a623 100%)",
          }}
        />

        <div style={{ textAlign: "center", marginBottom: "18px" }}>
          <img
            src="/arihant_logo.bd6c233c.png"
            alt="Arihant Logo"
            style={{ width: "90px", marginBottom: "8px" }}
          />
          <h2
            style={{
              fontSize: "26px",
              fontWeight: 700,
              color: "#f55a00",
              margin: "8px 0 4px",
            }}
          >
            Admin Dashboard
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "#666",
              margin: 0,
            }}
          >
            Sign in to manage transactions & tasks
          </p>
        </div>

        {error && (
          <div
            style={{
              backgroundColor: "#fff1f1",
              color: "#b3261e",
              padding: "9px 11px",
              borderRadius: "8px",
              fontSize: "13px",
              marginBottom: "14px",
              border: "1px solid #ffcccc",
              textAlign: "left",
            }}
          >
            {error}
          </div>
        )}

        {/* username */}
        <div style={{ marginBottom: "12px", textAlign: "left" }}>
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: 600,
              marginBottom: "5px",
              color: "#444",
            }}
          >
            Username
          </label>
          <div
            style={{
              borderRadius: "10px",
              border: "1px solid #e2e2e2",
              padding: "8px 10px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              backgroundColor: "#fafafa",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                color: "#f55a00",
                fontWeight: 600,
              }}
            >
              @
            </span>
            <input
              type="text"
              placeholder="Enter admin username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyPress={handleKeyPress}
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                width: "100%",
                fontSize: "14px",
                color: "#222",
              }}
            />
          </div>
        </div>

        {/* password */}
        <div style={{ marginBottom: "10px", textAlign: "left" }}>
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: 600,
              marginBottom: "5px",
              color: "#444",
            }}
          >
            Password
          </label>
          <div
            style={{
              borderRadius: "10px",
              border: "1px solid #e2e2e2",
              padding: "8px 10px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              backgroundColor: "#fafafa",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                color: "#999",
              }}
            >
              •••
            </span>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                width: "100%",
                fontSize: "14px",
                color: "#222",
              }}
            />
          </div>
        </div>

        {/* remember me */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "18px",
            fontSize: "13px",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#555",
              cursor: "pointer",
            }}
          >
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              style={{ accentColor: "#f55a00" }}
            />
            <span>Remember username</span>
          </label>
          <span style={{ color: "#aaa", fontSize: "12px" }}>
            Only one admin user
          </span>
        </div>

        {/* button */}
        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width: "100%",
            padding: "11px 0",
            borderRadius: "999px",
            background:
              "linear-gradient(135deg, #f55a00, #ff8c42 60%, #f5a623)",
            color: "#fff",
            fontWeight: 700,
            border: "none",
            fontSize: "15px",
            cursor: loading ? "default" : "pointer",
            boxShadow: "0 8px 18px rgba(245, 90, 0, 0.35)",
            transition: "transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s",
            opacity: loading ? 0.8 : 1,
          }}
          onMouseEnter={(e) => {
            if (!loading) {
              e.target.style.transform = "translateY(-1px)";
              e.target.style.boxShadow = "0 10px 24px rgba(245, 90, 0, 0.45)";
            }
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 8px 18px rgba(245, 90, 0, 0.35)";
          }}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <p
          style={{
            marginTop: "10px",
            fontSize: "11px",
            color: "#999",
            textAlign: "center",
          }}
        >
          Session is secured on server using PHP sessions.
        </p>
      </div>
    </div>
  );
};

export default Login;